import { WhySpaceMemberList } from '@tribeplatform/react-components/MemberList';
export const SpaceMemberListBlock = WhySpaceMemberList;
//# sourceMappingURL=Block.js.map